// Screenshot naming (M24, F2). Minecraft names captures by local timestamp; the
// pure formatter is split out so the zero-padding is unit-tested without a canvas.
// The capture itself (render a fresh frame → canvas.toDataURL → download) lives in
// boot, since it needs the renderer/scene/camera.

/** Minecraft-style capture filename for a given local time, e.g.
 *  `terraforge_2026-07-20_09.04.12.png`. */
export function screenshotFilename(date: Date): string {
  const p = (n: number): string => String(n).padStart(2, '0');
  const day = `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
  const time = `${p(date.getHours())}.${p(date.getMinutes())}.${p(date.getSeconds())}`;
  return `terraforge_${day}_${time}.png`;
}
